import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { PRIVACY_POLICY_PAGE_PATH } from "utils/constants/paths";

const PrivacyPolicyPage = Loadable(React.lazy(() => import("./View")));

export const PrivacyPolicyPageRoute: IRouteItem = {
  path: PRIVACY_POLICY_PAGE_PATH,
  element: React.createElement(PrivacyPolicyPage),
  name: "Privacy Policy",
};
